import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Reveal } from "@/lib/motion";
import { WHY } from "@/data/content";

export default function WhyChooseUs() {
  return (
    <section id="why" className="relative py-24 lg:py-32 bg-[#0F172A] text-white overflow-hidden scroll-mt-20" data-testid="why-section">
      <div className="absolute top-0 right-0 w-[30rem] h-[30rem] rounded-full opacity-20 blur-3xl" style={{ background: "#6C2BD9" }} />
      <div className="absolute bottom-0 left-1/4 w-96 h-96 rounded-full opacity-10 blur-3xl" style={{ background: "#F97316" }} />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <span className="overline text-[var(--dm-orange)]">Why Choose Us</span>
          <h2 className="font-head font-extrabold tracking-tighter text-4xl sm:text-5xl mt-4 leading-[1.05]">
            The partner that treats your growth like our own
          </h2>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {WHY.map((w, i) => {
            const Icon = Icons[w.icon] || Icons.Star;
            return (
              <motion.div
                key={w.title}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
                className="group rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-7 hover:bg-white/[0.07] hover:border-white/20 transition-colors duration-300"
                data-testid={`why-card-${i}`}
              >
                <div className="w-12 h-12 rounded-xl grid place-items-center mb-5 text-[var(--dm-orange)] bg-[var(--dm-orange)]/10 group-hover:scale-110 transition-transform duration-300">
                  <Icon size={22} />
                </div>
                <h3 className="font-head font-bold text-lg mb-2">{w.title}</h3>
                <p className="text-slate-400 leading-relaxed text-[0.95rem]">{w.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
